export const projectValue = (value, suffix = "") =>
  value === undefined || value === null || value === "" ? "–" : `${value}${suffix}`;

export const projectLeader = (project, employees = []) =>
  employees.find((employee) => employee.id === project.mandatsleitungId)?.name ||
  project.leaderName ||
  project.mandatsleitungId ||
  "–";

export const projectModification = (project) => {
  if (!project.updatedBy && !project.updatedAt) return null;
  const when = project.updatedAt
    ? new Date(project.updatedAt).toLocaleString("de-CH")
    : "–";
  return `${project.updatedBy || "–"} · ${when}`;
};

export const emptyProjectSnapshot = {
  phases: [],
  disposition: "nfx",
  plannedHours: 0,
};
